import { render, staticRenderFns } from "./correo_remitente.vue?vue&type=template&id=2b3c07f6&lang=pug&"
import script from "./correo_remitente.vue?vue&type=script&lang=js&"
export * from "./correo_remitente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports